(function(){
  function $(sel, root=document){ return root.querySelector(sel); }
  function $all(sel, root=document){ return Array.from(root.querySelectorAll(sel)); }

  async function uploadToCloudinary(file, cloudName, uploadPreset){
    const url = `https://api.cloudinary.com/v1_1/${cloudName}/auto/upload`;
    const fd = new FormData();
    fd.append('file', file);
    fd.append('upload_preset', uploadPreset);
    const res = await fetch(url, { method: 'POST', body: fd });
    if(!res.ok) throw new Error('Upload failed');
    return await res.json();
  }

  document.addEventListener('DOMContentLoaded', async () => {
    $all('[data-mg-uploader]').forEach((wrap) => {
      const input = $('[data-mg-file]', wrap);
      const list = $('[data-mg-list]', wrap);
      const hidden = $('[data-mg-hidden]', wrap);
      const status = $('[data-mg-status]', wrap);

      const cloudName = wrap.getAttribute('data-cloud-name');
      const uploadPreset = wrap.getAttribute('data-upload-preset');

      if(!input || !hidden || !cloudName || !uploadPreset) return;

      input.addEventListener('change', async () => {
        const files = Array.from(input.files || []);
        if(!files.length) return;

        status.textContent = 'Uploading photos…';
        status.style.opacity = '0.85';

        const urls = [];
        list.innerHTML = '';

        try{
          for (const f of files.slice(0, 6)) {
            const out = await uploadToCloudinary(f, cloudName, uploadPreset);
            const secureUrl = out.secure_url;
            urls.push(secureUrl);

            const li = document.createElement('li');
            li.textContent = secureUrl;
            list.appendChild(li);
          }
          hidden.value = urls.join('\n');
          status.textContent = 'Photos uploaded ✅ Links will be sent with your form.';
        } catch(e){
          hidden.value = '';
          status.textContent = 'Upload failed. Please use WeTransfer/Drive link instead.';
        }
      });
    });
  });
})();
